<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" align="middle">
        <el-col :span="4" style="padding-top: 10px;">
          <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-form :inline="true" ref="searchForm" :model="searchForm" class="search-form-inline">
            <el-form-item :label="generateCustomizeString('orderTimeRange')">
              <el-date-picker
                v-model="searchForm.datetimeRange"
                type="datetimerange"
                :picker-options="datetimeRangePickerOptions"
                range-separator="-"
                :start-placeholder="generateCustomizeString('start')"
                :end-placeholder="generateCustomizeString('end')"
                align="right"
              ></el-date-picker>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('transactionId')">
              <el-input
                v-model="searchForm.out_trade_no"
                :placeholder="generateCustomizeString('enterTransactionId')"
              ></el-input>
            </el-form-item>
            <el-form-item style="float: right; right: 30px;">
              <el-button type="primary" @click="onSearch">{{generateCustomizeString('search')}}</el-button>
              <el-button @click="onReset">{{generateCustomizeString('reset')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table
        :data="transactionData"
        tooltip-effect="dark"
        style="width: 100%; margin-bottom:60px;"
        v-loading.body="transactionListLoading"
      >
        <el-table-column prop="out_trade_no" :label="generateCustomizeString('transactionId')"></el-table-column>
        <el-table-column prop="customerName" :label="generateCustomizeString('customerName')"></el-table-column>
        <el-table-column prop="paymentAmount" :label="generateCustomizeString('paymentAmount')"></el-table-column>
        <el-table-column prop="paymentStatus" :label="generateCustomizeString('paymentStatus')"></el-table-column>
        <el-table-column prop="paymentMethod" :label="generateCustomizeString('paymentMethod')"></el-table-column>
        <el-table-column prop="paymentType" :label="generateCustomizeString('paymentType')"></el-table-column>
        <el-table-column prop="createTime" :label="generateCustomizeString('createTime')"></el-table-column>
        <el-table-column prop="finishTime" :label="generateCustomizeString('finishTime')"></el-table-column>
        <el-table-column :label="generateCustomizeString('operate')" width="160">
          <template slot-scope="scope">
            <el-button
              @click="viewTransaction(scope.$index)"
              type="text"
              size="small"
            >{{generateCustomizeString('viewTransaction')}}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :title="generateCustomizeString('transactionRecords')"
        :visible.sync="dialogTransactionRecordsVisible"
        width="80%"
      >
        <div style="padding-top: 30px;">
          <el-table
            :data="transactionRecords"
            tooltip-effect="dark"
            style="width: 100%"
            v-loading.body="transactionRecordsLoading"
          >
            <el-table-column
              prop="tradeCreateTime"
              :label="generateCustomizeString('tradeCreateTime')"
            ></el-table-column>
            <el-table-column prop="payType" :label="generateCustomizeString('payType')"></el-table-column>
            <el-table-column prop="payStatus" :label="generateCustomizeString('payStatus')"></el-table-column>
            <el-table-column
              prop="transactionMessage"
              :label="generateCustomizeString('transactionMessage')"
            ></el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:10px;">
      <el-row type="flex">
        <el-col style="padding-top: 5px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfTransactions"
            layout="total, prev, pager, next"
            :total="currentTotal"
          ></el-pagination>
        </el-col>
        <el-col>
          <div style="position: fixed; right: 30px;">
            <span style="font-size: 14px; color: #606266;">{{ generateCustomizeString('perPage') }}</span>
            <el-select
              v-model="numOfTransactions"
              style="width: 100px;"
              @change="selectNumOfTransactions()"
            >
              <el-option
                v-for="item in numOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import moment from 'moment'
import dayjs from 'dayjs'

const originTransactionSearchFrom = {
  datetimeRange: [],
  out_trade_no: ''
}
export default {
  name: 'TransactionList',
  // components: {
  // },
  props: {
    isOrderStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      filters: {},
      transactionData: [],
      transactionRecords: [],
      dialogTransactionRecordsVisible: false,
      transactionRecordsLoading: false,
      transactionListLoading: false,
      currentPage: 1,
      currentTotal: 0,
      numOfTransactions: 15,
      numOptions: [
        {
          value: 15,
          label: '15'
        },
        {
          value: 50,
          label: '50'
        },
        {
          value: 100,
          label: '100'
        }
      ],
      datetimeRangePickerOptions: {
        shortcuts: [
          {
            text: this.generateCustomizeString('lastWeek'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.generateCustomizeString('lastMonth'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.generateCustomizeString('lastThreeMonths'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      searchForm: Object.assign({}, originTransactionSearchFrom),
      multipleSelection: []
    }
  },
  methods: {
    generateCustomizeString,
    selectNumOfTransactions() {
      this.fetchTransactionData(1)
    },
    onSearch() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          if (this.searchForm.datetimeRange.length === 2) {
            const dates = this.searchForm.datetimeRange.map(date =>
              moment(date).format('YYYY-MM-DD HH:mm:ss')
            )
            dates[0] = new Date(dates[0]).getTime()
            dates[0] = this.getLocalTime(dates[0], 0)
            dates[0] = dayjs(new Date(dates[0])).format('YYYY-MM-DD HH:mm:ss')
            dates[1] = new Date(dates[1]).getTime()
            dates[1] = this.getLocalTime(dates[1], 0)
            dates[1] = dayjs(new Date(dates[1])).format('YYYY-MM-DD HH:mm:ss')
            params.start_created_at = dates[0]
            params.end_created_at = dates[1]
            delete params.datetimeRange
          }
          this.filters = params
          this.fetchTransactionData(1)
        } else {
          console.log('data error')
        }
      })
    },
    getLocalTime(date, i) {
      // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
      if (typeof i !== 'number') return
      var d = new Date(date)
      // 得到1970年一月一日到现在的秒数
      var len = d.getTime()
      // 本地时间与GMT时间的时间偏移差
      var offset = d.getTimezoneOffset() * 60000
      // 得到现在的格林尼治时间
      var utcTime = len + offset
      return new Date(utcTime - 3600000 * i)
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.searchForm = Object.assign({}, originTransactionSearchFrom)
      this.filters = {}
      this.fetchTransactionData(1)
    },
    onRefersh() {
      this.fetchTransactionData(this.currentPage)
    },
    viewClick(row) {
      this.$router.push({
        name: 'OrderView',
        params: { out_trade_no: row.out_trade_no }
      })
    },
    handleCurrentChange(val) {
      this.fetchTransactionData(val)
    },
    viewTransaction(index) {
      this.dialogTransactionRecordsVisible = !this
        .dialogTransactionRecordsVisible
      const recordsData = []
      if (this.transactionData[index].transaction_callback_records.length > 0) {
        for (
          var j = 0;
          j < this.transactionData[index].transaction_callback_records.length;
          j++
        ) {
          var sobj = {}
          sobj.tradeCreateTime = this.transactionData[
            index
          ].transaction_callback_records[j].created_at
          sobj.payType = this.getPaymentMethod(
            this.transactionData[index].transaction_callback_records[j].pay_type
          )
          sobj.payStatus = this.transactionData[
            index
          ].transaction_callback_records[j].status_name
          sobj.transactionMessage = this.transactionData[
            index
          ].transaction_callback_records[j].message

          recordsData[j] = sobj
        }
      }
      this.transactionRecords = recordsData
      console.log(this.transactionRecords)
    },
    getTransactionStatus(val) {
      var status = ''
      switch (val) {
        case 0:
          status = '未付款'
          break
        case 1:
          status = '已付款'
          break
        case 99:
          status = '已关闭'
          break
      }
      return status
    },
    getPaymentMethod(val) {
      var paymentMethod = ''
      switch (val) {
        case 'IE0011':
          paymentMethod = '支付宝二维码'
          break
        case 'IE0012':
          paymentMethod = '支付宝网页'
          break
        case 'IE0013':
          paymentMethod = '支付宝移动网页'
          break
        case 'IE0021':
          paymentMethod = '微信二维码'
          break
        case 'IE0022':
          paymentMethod = '微信移动网页'
          break
        case 'IE0111':
          paymentMethod = 'Paypal'
          break
        case 'IE8888':
          paymentMethod = '余额支付'
          break
        case 'IE9999':
          paymentMethod = '银行转账'
          break
      }
      return paymentMethod
    },
    fetchTransactionData(page) {
      if (this.transactionListLoading) return
      this.transactionListLoading = true

      request({
        url: '/transaction-list',
        method: 'get',
        params: {
          page: page,
          ...this.filters,
          page_size: this.numOfTransactions
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.out_trade_no = response.data[i].out_trade_no
            obj.customerName = response.data[i].customer.phone
            obj.paymentAmount = 'NZD $' + response.data[i].fee / 100
            obj.paymentStatus = this.getTransactionStatus(
              response.data[i].status
            )
            obj.createTime = response.data[i].created_at.replace(/-/g, '/')
            obj.createTime = dayjs(new Date(obj.createTime + ' UTC')).format(
              'YYYY-M-D HH:mm:ss'
            )
            if (response.data[i].finished_at) {
              obj.finishTime = response.data[i].finished_at.replace(/-/g, '/')
              obj.finishTime = dayjs(new Date(obj.finishTime + ' UTC')).format(
                'YYYY-M-D HH:mm:ss'
              )
            }
            // obj.paymentMethod = this.getPaymentMethod(response.data[i].pay_type)
            obj.paymentMethod = response.data[i].pay_type_string
            obj.paymentType =
              response.data[i].type === 1 ? '购买商品' : '余额充值'
            obj.transaction_callback_records =
              response.data[i].transaction_callback_records
            data[i] = obj
          }
          this.transactionData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.transactionListLoading = false
        })
    }
  },
  created: function() {
    this.fetchTransactionData(1)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
}

.search-form-inline {
  max-height: 60px;
}
</style>
<style type="text/css">
.el-dialog__wrapper {
  z-index: 10000 !important;
}
</style>
